import { render, staticRenderFns } from "./SanjivaniInstructorCardPrint.vue?vue&type=template&id=582f192e&scoped=true&"
import script from "./SanjivaniInstructorCardPrint.vue?vue&type=script&lang=js&"
export * from "./SanjivaniInstructorCardPrint.vue?vue&type=script&lang=js&"
import style0 from "./SanjivaniInstructorCardPrint.vue?vue&type=style&index=0&id=582f192e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582f192e",
  null
  
)

export default component.exports